import React, { PropsWithChildren } from "react";

import { Redirect } from "react-router-dom";

import useCheckPermission from "@fartherfinance/frontend/api/Authz/hooks/useCheckPermission";
import { ResourceCheck } from "@fartherfinance/frontend/api/Authz/requests/getAuthzCheck";
import {
  AdvisorRequestConfig,
  RequestConfig,
} from "@fartherfinance/frontend/api/Types";

import { FullScreenLoader, RequiresPermission } from "./UtilityComponents";

interface PermissionRouteProps {
  permissionCheck: ResourceCheck;
  auth: RequestConfig | AdvisorRequestConfig | null;
  redirectPath?: string;
  showPermissionError?: boolean;
}

const PermissionRoute: React.FC<PropsWithChildren<PermissionRouteProps>> = ({
  permissionCheck,
  auth,
  redirectPath,
  showPermissionError = false,
  children,
}) => {
  const { data, isLoading } = useCheckPermission(permissionCheck, auth);

  if (isLoading) {
    return <FullScreenLoader />;
  }

  if (data?.authorized === true) {
    return <>{children}</>;
  }

  if (redirectPath) {
    return <Redirect to={redirectPath} exact push={false} />;
  }

  if (showPermissionError) {
    return <RequiresPermission />;
  }

  return null;
};

export default PermissionRoute;
